import React from "react";
import "../ShareHolderInfo.scss";

import cashDividend2019 from "../../../files/shareholder-info/uncalim-stock-cash/List of Unclaimed Cash Dividend For The Year 2019 (Issue Year- 2020).pdf";
import cashDividend2017 from "../../../files/shareholder-info/uncalim-stock-cash/List of Unclaimed Cash Dividend For The Year- 2017 (Issue Year- 2018).pdf";

import cashDividend2016 from "../../../files/shareholder-info/uncalim-stock-cash/List of Unclaimed Stock Dividend For The Year- 2016 (Issue Year-2017).pdf";

import cashDividend2015 from "../../../files/shareholder-info/uncalim-stock-cash/List of Unclaimed Cash Dividend For The Year 2015 (Issue Year- 2016).pdf";
import cashDividend2013_16 from "../../../files/shareholder-info/uncalim-stock-cash/List of Unclaimed Cash Dividend For The Years 2013-2016 (Issue Years 2014-2017).pdf";

import stockDividend2018 from "../../../files/shareholder-info/uncalim-stock-cash/List of Unclaimed Stock Dividend For The Year- 2018 (Issue Year-2019).pdf";

import stockDividend2017 from "../../../files/shareholder-info/uncalim-stock-cash/List of Unclaimed Stock Dividend For The Year- 2017 (Issue Year-2018).pdf";

import stockDividend2009_16 from "../../../files/shareholder-info/uncalim-stock-cash/List of Unclaimed Stock Dividend For The Years 2009-2016 (Issue Years 2010-2017).pdf";

const UnclaimDividend = () => {
  return (
    <>
      <div className="shareholder_info">
        <div className="container">
          <div className="heading_box">List of Unclaim Stock/Cash Dividend</div>
          <div className="dividend_report_link">
            <div className="row">
              {/* cash dividend */}
              <div className="col-lg-6">
                <ul>
                  <li>
                    <a href={cashDividend2019} target="_blank" rel="noreferrer">
                      List of Unclaimed Cash Dividend For The Year 2019 (Issue
                      Year- 2020)
                    </a>
                  </li>

                  <li>
                    <a href={cashDividend2017} target="_blank" rel="noreferrer">
                      List of Unclaimed Cash Dividend For The Year- 2017 (Issue
                      Year- 2018)
                    </a>
                  </li>

                  <li>
                    <a href={cashDividend2016} target="_blank" rel="noreferrer">
                      List of Unclaimed Cash Dividend For The Year- 2016 (Issue
                      Year- 2017)
                    </a>
                  </li>

                  <li>
                    <a href={cashDividend2015} target="_blank" rel="noreferrer">
                      List of Unclaimed Cash Dividend For The Year 2015 (Issue
                      Year- 2016)
                    </a>
                  </li>

                  <li>
                    <a
                      href={cashDividend2013_16}
                      target="_blank"
                      rel="noreferrer"
                    >
                      List of Unclaimed Cash Dividend For The Years 2013-2016
                      (Issue Years 2014-2017)
                    </a>
                  </li>
                </ul>
              </div>
              {/* stock dividend */}
              <div className="col-lg-6">
                <ul>
                  <li>
                    <a
                      href={stockDividend2018}
                      target="_blank"
                      rel="noreferrer"
                    >
                      List of Unclaimed Stock Dividend For The Year- 2018 (Issue
                      Year-2019)
                    </a>
                  </li>

                  <li>
                    <a
                      href={stockDividend2017}
                      target="_blank"
                      rel="noreferrer"
                    >
                      List of Unclaimed Stock Dividend For The Year- 2017 (Issue
                      Year-2018)
                    </a>
                  </li>

                  <li>
                    <a
                      href={stockDividend2009_16}
                      target="_blank"
                      rel="noreferrer"
                    >
                      List of Unclaimed Stock Dividend For The Years 2009-2016
                      (Issue Years 2010-2017)
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UnclaimDividend;
